import {html, LitElement} from "lit";
import styles from "./store-locator.scss?inline";
import closeIconCircle from "../../assets/images/svg/close_icon.svg";
import {customElement, state} from "lit/decorators.js";
import {i18nService} from "../../services/i18nService";
import {icons} from "./icons/icons"

@customElement('login-dialog')
export class LoginDialog extends LitElement {

  @state() email: string = "";
  @state() password: string = "";
  @state() saveLogin: boolean = false;
  @state() error: boolean = false;

  constructor() {
    super();
    this.onPasswordChanged = this.onPasswordChanged.bind(this)
    this.onEmailChanged = this.onEmailChanged.bind(this)
    this.handleEnterPressed = this.handleEnterPressed.bind(this)
    this.closeModal = this.closeModal.bind(this)
  }

  async connectedCallback() {
    super.connectedCallback();
    await i18nService.initTranslations()
    this.requestUpdate()
    this.shadowRoot?.getElementById('dialog')?.addEventListener('click', this.closeModal)
  }

  onPasswordChanged(event: Event) {
    this.password = (event.target as HTMLInputElement).value;
  }

  onEmailChanged(event: Event) {
    this.email = (event.target as HTMLInputElement).value;
  }

  async handleEnterPressed(e: KeyboardEvent) {
    if (e.key === 'Enter') {
      await this.login(this.email, this.password, false)
    }
  }

  async login(email: string, password: string, permanent: boolean) {
    try {
      await window.NY_CUSTOMER_SERVICE.login(email, password, permanent)
      this.dispatchEvent(new CustomEvent('close'))
    } catch (e) {
      this.error = true
    }
  }

  closeModal() {
    this.error = false
    this.dispatchEvent(new CustomEvent('close'))
  }

  render() {
    return html`
      <style>${styles}</style>
      <div id="dialog" class="background active"></div>
      <div class="modal-container">
        <div class="close-container">
          <img @click=${this.closeModal} src="${closeIconCircle}"
               class="closeIcon"/>
        </div>
        <div class="modal-content">
          <div class="headline">
            <div class="error-container">
              ${this.error ? html`
                        ${icons.renderError()}
                        <p class="err">${i18nService?.translate("store.dialog.error")}</p>` :
                      html`<p>${i18nService?.translate("store.dialog.message")}</p>`}
            </div>
          </div>
          <div class="input-container">
            <input value="${this.email}" @input="${this.onEmailChanged}"
                   @keyup="${this.handleEnterPressed}" type="email" placeholder="E-Mail">
            <input value="${this.password}" @input="${this.onPasswordChanged}"
                   @keyup="${this.handleEnterPressed}" type="password" placeholder="Passwort">
          </div>
          <div class="forgot-password-container">
            <a href="https://www.newyorker.de/customer-profile/#/public/customer-profile/reset-password">Passwort
              vergessen?</a>
          </div>
          <div class="button-container">
            <button class="button register">
              <a href="https://www.newyorker.de/get-more-club/#/register">${i18nService?.translate("store.register")}</a>
            </button>
            <button class="button login" .disabled=${!(this.email.length && this.password.length)}
                    @click="${() => this.login(this.email, this.password, this.saveLogin)}">
              <a>${i18nService?.translate("store.login")}</a>
            </button>
          </div>
        </div>
      </div>
    `
  }
}